import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const CustomCursor: React.FC = () => {
  const cursorRef = useRef<HTMLDivElement>(null);
  const followerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const follower = followerRef.current;

    if (!cursor || !follower) return;

    const moveCursor = (e: MouseEvent) => {
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.1,
      });
      gsap.to(follower, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.3,
      });
    };

    const handleHover = () => {
      gsap.to(follower, {
        scale: 2,
        backgroundColor: 'rgba(212, 175, 55, 0.1)',
        borderColor: 'transparent',
        duration: 0.3,
      });
    };

    const handleHoverOut = () => {
      gsap.to(follower, {
        scale: 1,
        backgroundColor: 'transparent',
        borderColor: '#D4AF37',
        duration: 0.3,
      });
    };

    window.addEventListener('mousemove', moveCursor);

    // Add hover listeners to interactive elements
    const interactiveElements = document.querySelectorAll('a, button, input, textarea');
    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', handleHover);
      el.addEventListener('mouseleave', handleHoverOut);
    });

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      interactiveElements.forEach((el) => {
        el.removeEventListener('mouseenter', handleHover);
        el.removeEventListener('mouseleave', handleHoverOut);
      });
    };
  }, []);

  // Hide custom cursor on touch devices to avoid double cursor
  return (
    <div className="hidden md:block pointer-events-none fixed top-0 left-0 z-[9999] mix-blend-difference">
      <div
        ref={cursorRef}
        className="w-2 h-2 bg-diwan-gold rounded-full fixed -translate-x-1/2 -translate-y-1/2 pointer-events-none"
      />
      <div
        ref={followerRef}
        className="w-10 h-10 border border-diwan-gold rounded-full fixed -translate-x-1/2 -translate-y-1/2 pointer-events-none transition-transform"
      />
    </div>
  );
};

export default CustomCursor;